import { RestartManager } from './RestartManager';

/**
 * Singleton accessor for RestartManager.
 * Decoupled from init.ts to avoid pulling the entire coordinator graph
 * when hooks/components only need the RestartManager instance.
 *
 * Assigned during initializeCoordinators() — before that, a no-op stub
 * is returned so components can render in test environments. Mutating
 * calls (scheduleReboot, restartNow, cancelSchedule) throw on the stub
 * to surface accidental pre-init usage.
 */
let _instance: RestartManager | null = null;

export function setRestartManagerInstance(manager: RestartManager): void {
  _instance = manager;
}

const _stubIpc = { send: () => {} };
const _stubRewardsService = {} as any;
let _fallback: RestartManager | null = null;

export function getRestartManager(): RestartManager {
  if (_instance) return _instance;
  if (!_fallback) {
    _fallback = new RestartManager({ ipcService: _stubIpc as any, rewardsService: _stubRewardsService });
    _fallback.init();

    const throwPreInit = (method: string) => () => {
      throw new Error(`RestartManager.${method}() called before initializeCoordinators()`);
    };
    _fallback.scheduleReboot = throwPreInit('scheduleReboot');
    _fallback.restartNow = throwPreInit('restartNow');
    _fallback.cancelSchedule = throwPreInit('cancelSchedule');
  }
  return _fallback;
}
